<template>
  <div
    class="pt-radio-element-container"
  >
    <div
      v-if="!options.length"
      :class="containerClass"
      @input="onRadioItemClicked"
    >
      <slot />
    </div>
    <div
      v-else
      :class="containerClass"
    >
      <radio
        v-for="(radio, radioIndex) in options"
        :key="radioIndex"
        :name="name"
        :value="radio.value"
        :selected="selected"
        :label="radio.label"
        :is-customized="radio.isCustomized"
        @input="onRadioItemClicked"
        @customInput="onRadioItemClicked"
        @customDurationChanged="customDurationChanged"
      />
    </div>
  </div>
</template>

<script>
import Radio from './Radio';

export default {
  name: 'UnavailabilityModalRadioGroup',
  components: { Radio },
  props: {
    options: {
      type: Array,
      default: () => [],
      shape: `
      {
        value: Array<String, Number, Boolean>,
        label: String,
        isCustomized: Boolean,
      }`,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    isHorizontal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
  computed: {
    containerClass() {
      return {
        'flex': true,
        'flex-col': !this.isHorizontal,
      };
    },
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
  methods: {
    onRadioItemClicked(val) {
      // TODO: Determine why event is getting passed instead of value for slot based development
      const radioValue = val && val.type === 'input' ? val.target.value : val;
      if (this.selected !== radioValue) {
        this.selected = radioValue;
        this.$emit('input', radioValue);
      }
    },
    customDurationChanged(val) {
      this.$emit('customDurationChanged', val);
    },
  },
};
</script>
